export default __webpack_public_path__ + "static/media/pw.2c3ae64b.jfif";